import type { Metadata } from "next";
import AdminTermsConditions from "@/Component/Admin/ContentManagement/TermsConditions";

export const metadata: Metadata = {
    title: "Terms & Conditions | Connector Club",
};
const TermsAndConditions = () => {
    return (
        <AdminTermsConditions />
    )
}

export default TermsAndConditions
